import React from 'react';

import {
  StyledHorizontalBox,
  HeaderHorizontalBox
} from './StyledHorizontalBox';

export interface HorizontalBoxProps {
  header?: JSX.Element;
  hoverable?: boolean;
  size?: string;
  type?: string;
  backgroundImage?: string;
  fallbackBackground?: string;
  backgroundBox?: string;
  className?: string;
  disabled?: boolean;
}

const HorizontalBox: React.FC<HorizontalBoxProps> = props => {
  const {
    header,
    hoverable,
    size,
    type,
    backgroundImage,
    fallbackBackground,
    backgroundBox,
    children,
    className,
    disabled = false
  } = props;

  return (
    <StyledHorizontalBox
      size={size}
      type={type}
      hoverable={hoverable}
      backgroundBox={backgroundBox}
      disabled={disabled}
    >
      <HeaderHorizontalBox
        backgroundImage={backgroundImage}
        fallbackBackground={fallbackBackground}
        className={className}
      >
        {header}
      </HeaderHorizontalBox>

      {children}
    </StyledHorizontalBox>
  );
};

export default HorizontalBox;
